import React from "react";
import { Col, Form, Select, Row } from "antd";
import { ClientSectionSlot as BaseClientSectionSlot } from "../../common/components";

const { Option } = Select;

export const ClientSectionSlot = ({
    isNewClient,
    clientAddresses,
    ...baseProps
}) => {
    return (
        <>
            <BaseClientSectionSlot {...baseProps} />
            <Row gutter={16}>
                <Col xs={24}>
                    <Form.Item
                        name="Ship_to_Code"
                        label="Dirección de envío"
                        tooltip="Seleccione una dirección de envío del cliente"
                    >
                        <Select
                            showSearch
                            placeholder={
                                isNewClient
                                    ? "Cliente nuevo - Sin direcciones disponibles"
                                    : clientAddresses.length === 0
                                        ? "Cliente sin direcciones registradas"
                                        : "Seleccione una dirección de envío"
                            }
                            optionFilterProp="children"
                            allowClear={false}
                            disabled={!clientAddresses.length || isNewClient}
                            filterOption={(input, option) =>
                                (option?.label || "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                        >
                            {clientAddresses.map((address) => (
                                <Option
                                    key={address.Code}
                                    value={address.Code}
                                    label={`${address.Code} - ${address.Name} - ${address.Ciudad}, ${address.Provincia}`}
                                >
                                    <div>
                                        <strong>{address.Code}</strong> - {address.Name}
                                    </div>
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    {isNewClient && (
                        <div style={{ marginTop: "-16px", marginBottom: "16px" }}>
                            <small style={{ color: "#ff4d4f" }}>
                                ⚠️ El cliente seleccionado no está sincronizado con Business
                                Central. Las direcciones de envío no están disponibles para
                                clientes nuevos.
                            </small>
                        </div>
                    )}
                    {!isNewClient && clientAddresses.length === 0 && (
                        <div style={{ marginTop: "-16px", marginBottom: "16px" }}>
                            <small style={{ color: "#ff4d4f" }}>
                                ⚠️ Este cliente no tiene direcciones de envío registradas.
                                Debe agregar al menos una dirección para poder crear la
                                factura.
                            </small>
                        </div>
                    )}
                    {!isNewClient && clientAddresses.length === 1 && (
                        <div style={{ marginTop: "-16px", marginBottom: "16px" }}>
                            <small style={{ color: "#52c41a" }}>
                                ✓ Dirección seleccionada automáticamente (única dirección
                                disponible).
                            </small>
                        </div>
                    )}
                </Col>
            </Row>
        </>
    );
};
